<template>
  <v-card class="mb-1" :class="selectedClass">
    <v-card-actions>
      <v-btn @click="selectedStorage" text>{{ storage.name }}</v-btn>
      <v-spacer />
      <is-allowed role="CONTRIB">
        <storage-form
          edit
          :azureName="storage.azureName"
          :connectionStringKey="storage.connectionStringConfigKey"
          :storage="storage.name"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </template>
            <span>Edit {{ storage.name }}</span>
          </v-tooltip>
        </storage-form>
      </is-allowed>
      <storage-form
        v-role:contrib
        :azureName="storage.azureName"
        :connectionStringKey="storage.connectionStringConfigKey"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">
              mdi-content-copy
            </v-icon>
          </template>
          <span>Copy {{ storage.name }}</span>
        </v-tooltip>
      </storage-form>
      <storage-confirm-delete :storage="storage">
        <v-icon color="red">
          mdi-trash-can
        </v-icon>
      </storage-confirm-delete>
    </v-card-actions>
  </v-card>
</template>
<script>
import IsAllowed from '../../components/IsAllowed.vue'
import StorageConfirmDelete from './StorageConfirmDelete.vue'
import StorageForm from './StorageForm.vue'
export default {
  components: { StorageForm, StorageConfirmDelete, IsAllowed },
  name: 'StorageCard',
  props: {
    storage: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    selectedClass() {
      return this.isSelected ? 'grey lighten-2' : ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    selectedStorage() {
      this.$emit('selected', this.storage)
    }
  }
}
</script>
